module.exports = __webpack_public_path__ + "img/logoEF.78c58cb6.png";